
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1.999c5.524 0 10.002 4.478 10.002 10.002 0 5.523-4.478 10.001-10.002 10.001-5.524 0-10.002-4.478-10.002-10.001C1.998 6.477 6.476 1.999 12 1.999zm0 1.5a8.502 8.502 0 100 17.003A8.502 8.502 0 0012 3.5zM8.462 14.784A4.491 4.491 0 0012 16.502a4.491 4.491 0 003.535-1.714.75.75 0 111.177.93A5.991 5.991 0 0112 18.002a5.991 5.991 0 01-4.716-2.29.75.75 0 111.178-.928zM9 8.75a1.25 1.25 0 110 2.499A1.25 1.25 0 019 8.75zm6 0a1.25 1.25 0 110 2.499 1.25 1.25 0 010-2.499z","fill":"#212121","fill-rule":"nonzero"}})])
          )
        }
      }
    